<mat-sidenav-container class="eiq-grid-side-filter__container" (backdropClick)="backdropClick.emit()" autosize>
  <mat-sidenav #sidenav [(opened)]="opened" mode="over" [autoFocus]="true" position="end" [fixedInViewport]="true">
    <ng-content select="[slot=filter]"></ng-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <ng-content select="[slot=grid]"></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
